import type { WorkspaceMode } from '../types'

/**
 * `?mode=upscale` で開いたときだけ Upscale を初期 workspace にする（Mugen H3 の「✧ Upscale ページへ」の入口）。
 * `simple`／`multi` は受けない：それらは `profile.mode` も一緒に切り替える必要があり（`changeWorkspaceMode`）、
 * 初期化だけで分頁を変えると中身と食い違う。無い／他の値なら null＝従来どおり保存済み草稿に従う。
 */
export function workspaceModeFromSearch(search: string): WorkspaceMode | null {
  return new URLSearchParams(search).get('mode') === 'upscale' ? 'upscale' : null
}

interface EntryWindow {
  location: { search: string; pathname: string; hash: string }
  history: { replaceState: (data: unknown, unused: string, url?: string) => void }
}

/**
 * 入口の `mode` は**一度だけ**効かせる：読んだら URL から `mode` を外す（他の query と hash は残す）。
 * 残しておくと、その後 WAN の分頁に切り替えて再読み込みしたとき草稿より URL が勝って Upscale に戻ってしまう。
 */
export function takeEntryWorkspaceMode(win: EntryWindow): WorkspaceMode | null {
  const params = new URLSearchParams(win.location.search)
  if (!params.has('mode')) return null
  const mode = workspaceModeFromSearch(win.location.search)
  params.delete('mode')
  const search = params.toString()
  win.history.replaceState(null, '', `${win.location.pathname}${search ? `?${search}` : ''}${win.location.hash}`)
  return mode
}
